module.exports = __webpack_public_path__ + "ad6a06d84906dd55bc17e8ee7471e7ee.MP3";